import styled from "style/styled-components";

const FieldMargin = styled.div`
  flex: 1 0 auto;
  margin-bottom: ${({ theme }) => theme.margin.large};
  transition: height 0.2s ease-in-out;
`;

export default FieldMargin;
